import { redirect, createFileRoute } from '@tanstack/react-router';

/**
 * The address a task row hands out.
 *
 * `WgTaskRowDto.actionUrl` is `review/<ticketId>` relative to the brand's White
 * Glove route, which is a third spelling of the same destination. Forwarding it
 * costs one route file and removes a class of dead link.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId',
      params,
    });
  },
});
